<template></template>
<script>
export default {
  created() {
    this.$swal
      .fire("Formulário enviado com sucesso!", "", "success")
      .then(() => {});
  },
};
</script>